import * as types from "../actions/action-types";

const initialState = [];
export default function registryReducer(state = initialState, action) {
  switch (action.type) {
    case types.EVENT_PARTICIPANTS:
      return Object.assign({}, state, {
        eventParticipants: action.eventParticipants,
        eventParticipantsRequested: action.eventParticipantsRequested,
        eventParticipantsEventIndex: action.eventParticipantsEventIndex,
      });
    case types.EVENT_PARTICIPANTS_CHANGED:
      var key = action.eventParticipantsChangedKey;
      return Object.assign({}, state, {
        eventParticipants: Object.assign({}, state.eventParticipants, {
          [key]: action.eventParticipantsChanged,
        }),
      });
    case types.EVENT_PARTICIPANTS_REMOVED:
      var key = action.eventParticipantsChangedKey;
      var stateNew = {};
      for (var i in state.eventParticipants) {
        if (i != key) {
          stateNew[i] = state.eventParticipants[i];
        }
      }
      return Object.assign({}, state, {
        eventParticipants: stateNew,
      });
    case types.EVENT_PARTICIPANTS_BATCH:
      var merged = { ...state.eventParticipants, ...action.eventParticipantsUpserts };
      (action.eventParticipantsRemoved || []).forEach((removedKey) => {
        delete merged[removedKey];
      });
      return Object.assign({}, state, {
        eventParticipants: merged,
      });
    case types.REGISTRY_PARTICIPANT_DATA:
      return Object.assign({}, state, {
        registryParticipantData: action.registryParticipantData,
        registryParticipantKey: action.registryParticipantKey,
        registryError: action.registryError,
      });
    case types.REGISTRY_FORM_DATA:
      return Object.assign({}, state, {
        registryFormtData: action.registryFormtData,
        registryFormtKey: action.registryFormtKey,
        registryError: action.registryError,
      });
    case types.FORM_DATA:
      return Object.assign({}, state, {
        formData: action.formData,
        inputGroup: action.inputGroup,
      });
    case types.RESET_REGISTRY_PARTICIPANT_DATA:
      return Object.assign({}, state, {
        registryParticipantData: action.registryParticipantData,
        registryParticipantKey: action.registryParticipantKey,
        registryError: action.registryError,
      });
    case types.REGISTRY_CONFIGURATION:
      return Object.assign({}, state, {
        registryConfiguration: action.registryConfiguration,
      });

    case types.REGISTRY_AUTORIZED_USERS:
      return Object.assign({}, state, {
        registryAutorizedUsers: action.registryAutorizedUsers,
      });

    case types.EVENT_CAMPAIGNS:
      return Object.assign({}, state, {
        eventCampaigns: action.eventCampaigns,
      });

    case types.CODES_LIST:
      return Object.assign({}, state, {
        codesList: action.codesList,
      });
    case types.CODES_GROUPS:
      return Object.assign({}, state, {
        codesGroups: action.codesGroups,
      });

    default:
      return state;
  }
}
